<template>
  <div>
    <component
      :is="level"
      :class="[ $style.base,
                $style[level],
                color === 'turquoise' ? $style.turquoise : $style.jet
      ]"
      v-bind="$attrs"
    >
      <slot />
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface HeadingProps {
  semanticLevel?: number
  displayLevel?: number
  color?: 'jet' | 'turquoise'
}

const {
  semanticLevel = 1,
  displayLevel,
  color = 'jet'
} = defineProps<HeadingProps>()

defineOptions({
  inheritAttrs: false
})

const level = computed(() => {
  const l = displayLevel || semanticLevel
  return 'h' + l
})

</script>

<style module>
.base {
  font-family: var(--font-heading);
}

.h1 {
  font-size: clamp(20px, 2vw, 22px);
  line-height: clamp(24px, 2vw, 26px);
  margin: 0;
  font-weight: 600;
}

.h2 {
  font-size: clamp(18px, 2vw, 20px);
  line-height: clamp(22px, 2vw, 24px);
  margin: 0;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.h3 {
  font-size: clamp(16px, 2vw, 18px);
  line-height: clamp(19px, 2vw, 21px);
  margin: 0;
  font-weight: 500;
}

.jet {
  color: var(--color-jet);
}

.turquoise {
  color: var(--color-turquoise);
}
</style>
